import { DocumentNode } from 'graphql';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import addAwardsSuggestionMutation from '../../mutations/addAwardsSuggestion';
import addCollaborativeFilteringSuggestionMutation from '../../mutations/addCollaborativeFilteringSuggestion';
import addHighDemandSuggestionMutation from '../../mutations/addHighDemandSuggestion';
import addPopularSuggestionMutation from '../../mutations/addPopularSuggestion';
import addSearchSuggestionMutation from '../../mutations/addSearchSuggestion';
import searchQuery from '../../queries/searchSuggestions';
import { UtilMixin } from '../../UtilMixin';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import BooksCarousel from './booksCarousel.vue';

@Component({ components: { BooksCarousel, SingleMainContainer } })
export default class SuggestionsListOpenSearchAdder extends Mixins(UtilMixin) {
  @Prop() public suggestionsList!: any;

  public readonly query = searchQuery;

  get keywords() {
    return this.suggestionsList?.project?.requirements?.keywords || [];
  }

  public queryVariables(openValue: string, extra: any): any {
    return {
      query: openValue,
      tenantId: this.suggestionsList.library.id,
      suggestionsListId: this.suggestionsList.id,
      options: {
        awards: extra && extra.includes('AWARDS'),
        popular: extra && extra.includes('MISSING_POPULAR'),
        collaborativeFiltering:
          extra && extra.includes('COLLABORATIVE_FILTERING'),
        highDemand: extra && extra.includes('HIGH_DEMAND'),
        others: extra && extra.includes('OTHERS'),
      },
    };
  }

  public mutation(suggestionCandidate: any): DocumentNode {
    console.log(JSON.stringify(suggestionCandidate));
    if (this.isSuggestionEntrySearch(suggestionCandidate)) {
      return addSearchSuggestionMutation;
    }

    if (this.isSuggestionEntryMissingPopular(suggestionCandidate)) {
      return addPopularSuggestionMutation;
    }

    if (this.isSuggestionAwards(suggestionCandidate)) {
      return addAwardsSuggestionMutation;
    }

    if (this.isSuggestionEntryHighDemand(suggestionCandidate)) {
      return addHighDemandSuggestionMutation;
    }

    if (this.isSuggestionEntryHighDemand(suggestionCandidate)) {
      return addHighDemandSuggestionMutation;
    }

    if (this.isSuggestionEntryCollaborativeFiltering(suggestionCandidate)) {
      return addCollaborativeFilteringSuggestionMutation;
    }

    throw new Error('suggestion type not found?');
  }

  public mutationVariables(suggestionCandidate: any): any {
    if (this.isSuggestionEntrySearch(suggestionCandidate)) {
      return {
        suggestionsListId: this.suggestionsList.id,
        query: suggestionCandidate.source.query,
        publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
      };
    }

    if (this.isSuggestionEntryMissingPopular(suggestionCandidate)) {
      return {
        suggestionsListId: this.suggestionsList.id,
        publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
        loans: suggestionCandidate.source.loans,
        libraries: suggestionCandidate.source.libraries,
      };
    }

    if (this.isSuggestionAwards(suggestionCandidate)) {
      return {
        suggestionsListId: this.suggestionsList.id,
        publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
        awards: suggestionCandidate.source.awards,
      };
    }

    if (this.isSuggestionEntryHighDemand(suggestionCandidate)) {
      return {
        suggestionsListId: this.suggestionsList.id,
        publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
        bookings: suggestionCandidate.source.bookings,
        maxSimultaneous: suggestionCandidate.source.maxSimultaneous,
      };
    }

    if (this.isSuggestionEntryCollaborativeFiltering(suggestionCandidate)) {
      return {
        suggestionsListId: this.suggestionsList.id,
        publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
        position: suggestionCandidate.source.position,
        among: suggestionCandidate.source.among,
      };
    }
  }
}
